/**
 * ملخص حسب المديرية — مدى تاريخي حر (ميلادي)
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DateRangeFilter, { defaultRange } from "../../components/shared/DateRangeFilter";
import type { DateRange } from "../../components/shared/DateRangeFilter";
import PivotTable from "../../components/shared/PivotTable";
import PrintLayout from "../../components/Layout/PrintLayout";
import { formatDate } from "../../lib/date";
import { useReport, exportCsv } from "./useReport";
import MeasureToggle from "../../components/shared/MeasureToggle";
import { MEASURE_LABELS } from "../../types";
import type { Measure } from "../../types";

const PATH = "/reports/by-directorate";

export default function SummaryDirectoratesPage() {
  const [range, setRange] = useState<DateRange>(defaultRange());
  const navigate = useNavigate();
  const [measure, setMeasure] = useState<Measure>("requested");
  const { data, isLoading, error } = useReport(PATH, range, true, measure);
  const title = `الملخص حسب المديرية — ${MEASURE_LABELS[measure]}`;

  return (
    <div>
      <div className="page-header flex items-start justify-between">
        <div>
          <h1 className="page-title">الملخص حسب المديرية</h1>
          <p className="page-subtitle">إجمالي الكميات خلال المدى المحدد — حدّد صفوفاً لرؤية مجموعها</p>
        </div>
        <div className="flex gap-2 print:hidden">
          <button className="btn-secondary" onClick={() => exportCsv(PATH, range, measure)} disabled={!data}>
            تصدير CSV
          </button>
          <button className="btn-secondary" onClick={() => window.print()} disabled={!data}>
            طباعة
          </button>
        </div>
      </div>

      <div className="print:hidden">
        <DateRangeFilter value={range} onChange={setRange} />
      </div>
      <MeasureToggle value={measure} onChange={setMeasure} />

      {isLoading && <div className="card text-center text-gray-400 py-10">جاري التحميل...</div>}
      {error     && <div className="alert-error">تعذّر تحميل التقرير</div>}
      {data      && <PrintLayout title={title} subtitle={`من ${formatDate(range.from)} إلى ${formatDate(range.to)}`}><PivotTable report={data} firstColLabel="المديرية" selectable
                       onRowClick={(id) => navigate(`/summary/directorate/${id}?from=${range.from}&to=${range.to}`)} /></PrintLayout>}
    </div>
  );
}
